/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { CargoLoss } from "./modelCargoLoss";

class ControllerCargoLoss extends ControllerModel {
  constructor() {
    super("ControllerCargoLoss");
    
    this.setNewNode = (callback) => {
      let cargoLoss = new CargoLoss();
      cargoLoss.decorate(callback);

      this.addNode(cargoLoss);
      SingletonFlowchart.SaveStatus()
    }

    this.loadNode = (node, callback) => {
      let cargoLoss = new CargoLoss();
      cargoLoss.copyFrom(node);
      cargoLoss.decorate(callback);
      this.addNode(cargoLoss)
    }

    this.getProperties = async (node) => {
      let n = new CargoLoss();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new CargoLoss();
      n.copyFrom(node);
      return n
    } 
  }
}

export { ControllerCargoLoss };
